export const API = {
  // PARTY
  party: {
    // V1
    V1__FETCH__LENDER: () => '/api/v1/party/lender',
    V1__FETCH__ADDRESS: () => `/api/v1/party/address`,
    V1__FETCH__LENDER_ADDRESS__BY_ID: id => `/api/v1/party/lender/${id}/addresses`,
  },
  parties: {
    // V2
    FETCH__RELATIONS: id => `/api/v2/parties/relations`,
  },
  // REFERRENTIAL
  referential: {
    // V2
    FETCH__LENDER: () => '/api/v2/referential/lenders',
    FETCH__LENDER_ADDRESS__BY_ID: id => `/api/v2/referential/lenders/${id}/addresses`,
  },
};
